import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { ActivityMediumLink } from '@/components/activities/ActivityMediumLink';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconAnalysisValidation from '@/icons/AnalysisValidation.svg';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const ArticleAnalysisCompletedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_analysis_completed'>;
  displayArticleName: boolean;
}) => {
  const { iam } = useRequestContext();

  const workshopName = activity.workshop.name;
  const creatorName = activity.creator?.name;

  const userWorkshopIds = iam.scopesOnRequest
    .filter(({ scope }) => scope === 'workshop')
    .map(({ entityId }) => entityId);
  const hideQuote =
    iam.hasOnlyWorkshopScopeOnRequest && !userWorkshopIds.includes(activity.workshopId);

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconAnalysisValidation />}
      message={
        <BaseActivityText>
          {activity.data?.onBehalfOfWorkshop ? (
            <Trans id="activities.article_analysis_completed.message.on-behalf">
              <strong>{creatorName}</strong> completed the analysis of the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />{' '}
              on behalf of <strong>{workshopName}</strong>
            </Trans>
          ) : (
            <Trans id="activities.article_analysis_completed.message">
              <strong>{creatorName}</strong> completed the analysis of the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      {activity.medium && !hideQuote && <ActivityMediumLink medium={activity.medium} />}
    </BaseActivity>
  );
};
